<template>
    <div class="content">


      <div>
        <div style="padding-top: 20px;"></div>
      
        <div style="display: none;"></div>
        <div ref="alipayWeb" v-html="alipay" style="display: none;"></div>
        <div class="moble-form-class" v-if="isMobile">

            <div style="text-align: center;">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : 1</p>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" >
               <el-form-item label="提示"><span style="color: crimson;font-size: xx-small;">(支付前請先搜索賬號是否存在，以免失敗)</span></el-form-item>
                <el-form-item label="賬號" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name" placeholder="請輸入遊戲賬號" >
                      <el-button slot="append" icon="el-icon-search" @click="queryAccount"></el-button>
                   
                    </el-input> 
                       
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id" v-if="accounts.length > 0">
                  <el-tag type="success" v-for="(tag,index) in accounts" :key="index">{{ tag.game_char }}</el-tag>&nbsp;&nbsp;
                </el-form-item>
                <!--<el-form-item label="確認賬號" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>-->
                <el-form-item label="金額" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="10" :max="100000000" :step="1" @change="queryJF"></el-input-number>
                </el-form-item>
                <el-form-item label="備註" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>

        </div>
         <div class="form-class" v-else>

            <div style="text-align: center;">
              <h1>{{ server_name }}</h1>
              <p style="color: red;">充值比例：1 : 1</p>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" >
               <el-form-item label="提示"><span style="color: crimson;font-size: xx-small;">(支付前請先搜索賬號是否存在，以免失敗)</span></el-form-item>
                <el-form-item label="賬號" prop="game_account_name">
                    <el-input v-model="ruleForm.game_account_name" placeholder="請輸入遊戲賬號" >
                      <el-button slot="append" icon="el-icon-search" @click="queryAccount"></el-button>
                   
                    </el-input> 
                       
                </el-form-item>
                <el-form-item label="角色" prop="game_char_id" v-if="accounts.length > 0">
                  <el-tag type="success" v-for="(tag,index) in accounts" :key="index">{{ tag.game_char }}</el-tag>&nbsp;&nbsp;
                </el-form-item>
                <!--<el-form-item label="確認賬號" prop="agin_game_account_name">
                    <el-input v-model="ruleForm.agin_game_account_name"></el-input>     
                </el-form-item>-->
                <el-form-item label="金額" prop="amt">
                    <el-input-number v-model="ruleForm.amt" :min="10" :max="100000000" :step="1" @change="queryJF"></el-input-number>
                </el-form-item>
                <el-form-item label="備註" prop="remark">
                    <el-input v-model="ruleForm.remark" type="textarea"  :rows="2"></el-input>
                </el-form-item>
                
                <div id="card-element" style="background-color:white"></div>
                <el-form-item>
                    <el-button type="success" @click="submitForm('ruleForm')" :loading="payBtn">立即支付</el-button>
                </el-form-item>
            </el-form>

        </div>
      </div>

    </div>
</template>
<script>
import {Form, Message} from 'element-ui';
import { loadStripe } from '@stripe/stripe-js';
  export default {
    data() {
      return {
        stripe: null,
        cardElement: null,
        isMobile: false,
        ruleForm: {
          serviceId:'',
          service_id:'',
          usdt:2,
          remark:'',
          game_account_name:'',
          user_type:0,
          amt:10
        },
        qjf:{},
        commission:0.003,
        accounts:[],
        paymentType:false,
        payBtn:false,
        tip:'請掃碼支付',
        tipFlag:true,
        options:[],
        u_scale : 1,
        orderNo:'',
        server_name:'',
        alipay:'',
        out_pay_url:'',
        rules: {
          amt: [
            { required: true, message: '請填寫金額', trigger: 'blur' },
            
          ],
          game_account_name: [
            { required: true, message: '請輸入遊戲賬號', trigger: 'blur' },
          ],
        }
      };
    },
    async created(){
  
        this.isMobile = window.innerWidth < 768;
        console.log(this.isMobile);
        let self = this;
        var url = window.location.href ;             //獲取當前url
        var cs={};
        if(url.indexOf('#') > -1 && url.indexOf('?') > -1 &&  url.indexOf('&') > -1){ 
            var dz_url = url.split('#')[0];                //獲取#/之前的字符串
            var csstr = dz_url.split('?')[1];                //獲取?之後的參數字符串
            var cs_arr = csstr.split('&');                    //參數字符串分割為數組
       
            for(var i=0;i<cs_arr.length;i++){         //遍歷數組，拿到json對象
              if(cs_arr[i]){
                if(cs_arr[i].split('=')){
                  cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1] 
                }
              }
            }
        }
    
        if(cs.service_id){ 
           //這樣就拿到了參數中的數據
            self.ruleForm.serviceId = cs.service_id;   
     
        }else{
            self.ruleForm.serviceId = '44f714b60a064f738b1dd56a9c16ad4c'
        }
        self.ruleForm.service_id = self.ruleForm.serviceId;    
        this.getParam();
        this.queryCommission();
        this.queryJF();
        await this.st();
    },
    methods: {
      async st(){
           // 1. 加载 Stripe.js 和 Elements
          this.stripe = await loadStripe('pk_test_51SgOGc8cwYPKzEDf0TU5KsFngzTwbyC5JKt0mN2jCgSuX5R9DFdduTLvslTLMMdTOCNsl9PXgVqNv8kYhLXapLdo00xnu234rl'); // 替换为你的公钥
          const elements = this.stripe.elements();

          // 2. 创建卡片元素
          this.cardElement = elements.create('card', {
            style: {
              base: {
                fontSize: '16px',
                color: '#32325d',
              },
            },
          });

          // 3. 将卡片元素挂载到 DOM
          this.cardElement.mount('#card-element');
      },
      paymentBtn(){
        window.open(this.out_pay_url, "_blank");

       // window.location.href= "http://app.sxzbd.com/pay/tbNg";
      },
      queryCommission(){
        let self = this;
        self.postRequest('/usdt/commission',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.commission = resp.data;
        })
      },
      queryAccount(){
        let self = this;
        self.postRequest('/game/characters_list',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.accounts = resp.data;
        })
      },
      queryJF(){
        let self = this;
        this.ruleForm.price = self.ruleForm.amt;
        self.postRequest('/order/integral_price',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.qjf = resp.data;
        })
      },
      submitForm(formName) {
          let self = this;
          self.payBtn = true;
          self.$refs[formName].validate((valid) => {
          if (valid) {
            self.postRequest('/stripe/pay',self.ruleForm).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                
                 console.log(resp.data);
                self.goStripePay(resp.data);

            })


          } else {
            self.payBtn=false;
            console.log('error submit!!');
            return false;
          }
        });
      },
      async goStripePay(pay_secret){ 
      
        const { paymentIntent, error } = await this.stripe.confirmCardPayment(
              pay_secret, // 从后端获取
              {
                payment_method: {
                  card: this.cardElement,
                  billing_details: {
                    name: 'John Doe', // 示例，实际应来自用户输入
                  },
                },
              }
            );

            if (error) {
              console.error(error);
              // 处理错误
            } else {
              // 支付成功，跳转到成功页面或更新UI
              console.log('Payment successful:', paymentIntent);
              // 通常在这里调用后端接口，通知服务器支付成功
              this.postRequest('/stripe/webhook',paymentIntent).then(resp =>{
                 self.payBtn=false;
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 console.log(resp.data);
            })
            }

      },
      getParam(){
        let self = this;
  
        console.log("this.ruleForm.service_id:"+self.ruleForm.service_id);

        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                self.out_pay_url = resp.data.out_pay_url;
                self.u_scale = resp.data.u_scale;
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
            })

       

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      
  
      handleClose(done) {
        this.$confirm('確認關閉？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
    },
  }
</script>
<style scoped>

    .content{
     
        margin-top: 50px;
        width: 100%;
          /* 水平垂直都居中 */
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center;     /* 垂直居中 */
   
      
    }
    .form-class{
        padding-top: 50px;
        padding-left: 100px;
        padding-right: 100px;
        width: 100%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
     
    }
    .moble-form-class{
      padding-top: 30px;
       width: 100%;
        height: 500px;
        max-height: 800px;
        background-color: rgb(55, 155, 153);
        border-radius: 20px;
    }

</style>